import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=1636c6cf&scoped=true&"
var script = {}
import style0 from "./Language.vue?vue&type=style&index=0&id=1636c6cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1636c6cf",
  null
  
)

export default component.exports